import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../hooks/AuthProvider/AuthProvider";

const PrivateRoute = () => {
  const { token, sessionLoading } = useAuth();

  // Esperar verificación de sesión antes de redirigir
  if (sessionLoading) return null;
  if (!token) return <Navigate to="/" />;
  return <Outlet />;
};

export default PrivateRoute;